/** @format */

import { asyncType } from "redux/types/asyncTypes";

export const FETCH_REPORTS = asyncType("FETCH_REPORTS");
export const FETCH_DETAILS = asyncType("FETCH_DETAILS");
